import React from "react";

const ModuleDisplayColor = ({ value }) => {
  if (!value) return <span>-</span>; // fallback if no color

  const isVeryLightColor = (color) => {
    // quick check to avoid invisible text for light colors like #fff
    const hex = color.replace("#", "");
    if (hex.length !== 6) return false;
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  const safeTextColor = isVeryLightColor(value) ? "#808080" : value;

  return (
    <div className="d-inline-flex align-items-center">
      <div
        style={{
          width: "12px",
          height: "12px",
          backgroundColor: value,
          border: "1px solid #ccc",
          borderRadius: "4px",
          marginRight: "6px",
        }}
      ></div>
      <span style={{ color: safeTextColor }}>{value}</span>
    </div>
  );
};

export default ModuleDisplayColor;
